import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-search-toolbar',
    templateUrl: './search-toolbar.component.html',
    styleUrls: [
        './search-toolbar.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchToolbarComponent
{
}
